<style scoped>

</style>
<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="value"
        :label="label"
        :placeholder="placeholder"
        :required="required"
        :rules="rules"
        :disabled="disabled"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="date"
      no-title
      :locale="locale"
      :allowed-dates="allowedDates"
      :type="type"
      scrollable
    >
      <v-spacer />
      <v-btn
        text
        color="primary"
        @click="menu = false"
      >
        取消
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="confirm"
      >
        确定
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>
<script>
  export default {
    props: {
      value: {
        type: String
      },
      label: {
        type: String,
        default: '选择日期'
      },
      placeholder: {
        type: String,
        default: '点击选择'
      },
      locale: {
        type: String,
        default: 'zh'
      },
      required: {
        type: Boolean,
      },
      rules: {
        type: Array,
      },
      allowedDates: {
        type: Function,
        default: () => true
      },
      type: {
        type: String,
        default: () => undefined
      },
      clearable: {
        type: Boolean,
        default: () => false
      },
      disabled: {
        type: Boolean,
        default: () => false
      }
    },
    data() {
      return {
        menu: false,
        date: ''
      }
    },
    methods: {
      confirm() {
        this.$refs.menu.save(this.date);
        this.$emit('input', this.date);
      }
    }
  }
</script>
